import { precacheDynamicOdspDriver } from '@fluidx/odsp-driver-codeloader';
import { Environment } from '@fluidx/office-fluid-types';
import { Locale, resolveLocale } from '@fluidx/utilities';
import { OfficeWebHostPrecacheConfig, precache } from '@ms/office-web-host';
import { getLogicalRing } from 'owa-config';
import { getCurrentLanguage } from 'owa-localize';

let isFluidPreloaded: boolean = false;

export function isPreloadFluidInCollabSpaceComplete() {
    return isFluidPreloaded;
}

export function preloadFluidScripts() {
    const logicalRing = getLogicalRing();
    const environment: Environment =
        logicalRing === 'Dogfood' ? { audience: 'Dogfood' } : { audience: 'Production' };
    const locale = getCurrentLanguage();
    const fluidLocale: Locale = resolveLocale(locale);
    const config: OfficeWebHostPrecacheConfig = {
        environment: environment,
        locale: fluidLocale,
    };
    precache(config);
    precacheDynamicOdspDriver({
        environment: environment,
    });

    isFluidPreloaded = true;
}
